import { useQuery } from 'react-query';
import { equipmentAPI } from '../services/api';

// How many checked-out ramps/equipment are past their due date — the badge on
// the Ramps tab. Pass enabled=false when the user can't see that tab. The
// Ramps page and live 'equipment' updates invalidate 'equipment-summary'; the
// interval catches items that go past due overnight.
export default function useEquipmentPastDue(enabled) {
  const { data } = useQuery(
    'equipment-summary',
    () => equipmentAPI.summary().then(r => r.data),
    { enabled: !!enabled, refetchInterval: 5 * 60 * 1000, staleTime: 60 * 1000 }
  );
  return enabled ? (data?.pastDue || 0) : 0;
}
